// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Input_Wrapper__xr0dQ","Title":"Input_Title__129xm","Input":"Input_Input__34q-5"};